<template>
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.79945 13.1283L10.6295 10.2983L3.60945 3.28832C2.04945 4.84832 2.04945 7.37832 3.60945 8.94832L7.79945 13.1283ZM14.5795 11.3183C16.1095 12.0283 18.2595 11.5283 19.8495 9.93832C21.7595 8.02832 22.1295 5.28832 20.6595 3.81832C19.1995 2.35832 16.4595 2.71832 14.5395 4.62832C12.9495 6.21832 12.4495 8.36832 13.1595 9.89832L3.39945 19.6583L4.80945 21.0683L11.6995 14.1983L18.5795 21.0783L19.9895 19.6683L13.1095 12.7883L14.5795 11.3183Z"
      fill="currentColor"
    />
  </svg>
</template>
